import sanitizeHtml from 'sanitize-html';

export function sanitizeHTML(html: string) {
  if (!html) return '';
  // FIXME sanitize
  // - Ignore <script> tag
  // - Use CKEditor preview process if possible
  return sanitizeHtml(html, {
    allowedTags: false,
    allowedAttributes: false,
  });
}
